"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateToV2 = void 0;
var lodash_1 = require("lodash");
var versions_1 = require("@wix/wix-vod-constants/dist/app-settings/versions");
/* Don't change settings here! To change settings behavior, create new version */
/* This version includes addition of parameters for compact action bar.
 Using old colors for old users */
function migrateToV2(appSettingsV1) {
    var _a = appSettingsV1.colors, colors = _a === void 0 ? {} : _a;
    var backgroundColor = colors.backgroundColor, buttonsAndLinksColor = colors.buttonsAndLinksColor, compactMenuBackgroundColor = colors.compactMenuBackgroundColor, compactMenuActionsColor = colors.compactMenuActionsColor;
    return (0, lodash_1.merge)({}, appSettingsV1, {
        numbers: {
            settingsVersion: versions_1.APP_SETTINGS_VERSION_2,
        },
        colors: {
            compactMenuBackgroundColor: compactMenuBackgroundColor || backgroundColor,
            compactMenuActionsColor: compactMenuActionsColor || buttonsAndLinksColor,
        },
    });
}
exports.migrateToV2 = migrateToV2;
//# sourceMappingURL=version-2.js.map